import clsx from 'clsx';
import React, { Component } from 'react';
import GapAwareEventRowMixin from './gapAwareEventRowMixin';

export default class GapAwareEventRow extends Component {
  render() {
    const { segments, slotMetrics, className } = this.props;
    const slots = slotMetrics.slots;
    let lastEnd = 1;
    return (
      <div className={clsx(className, 'rbc-row')}>
        {segments.reduce((row, seg, li) => {
          const { event, left, right, span } = seg;
          const key = `_lvl_${li}`;
          const gap = left - lastEnd;
          const content = GapAwareEventRowMixin.renderEvent(this.props, event);
          if (gap) {
            row.push(GapAwareEventRowMixin.renderSpan(slots, gap, `${key}_gap`));
          }
          row.push(GapAwareEventRowMixin.renderSpan(slots, span, key, content));
          lastEnd = right + 1;
          return row;
        }, [])}
      </div>
    );
  }
}

GapAwareEventRow.defaultProps = { ...GapAwareEventRowMixin.defaultProps };
